import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

/**
 * SetHomepageButton — appears on supported pages.
 * Clicking it saves that page as the user's landing page after login.
 * Props:
 *   pagePath — the route path of the page (e.g. '/news-feed')
 */
const SetHomepageButton = ({ pagePath }) => {
  const { user, updateLandingPage } = useAuth();
  const [saving, setSaving] = useState(false);

  if (!user) return null;

  const isActive = (user.landing_page || '/amplifier_search') === pagePath;

  const handleClick = async () => {
    if (isActive || saving) return;
    setSaving(true);
    await updateLandingPage(pagePath);
    setSaving(false);
  };

  return (
    <button
      onClick={handleClick}
      disabled={isActive || saving}
      title={isActive ? 'This is your home page' : 'Set as your home page'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '4px 12px',
        fontSize: '12px',
        fontWeight: '600',
        borderRadius: '20px',
        border: `1px solid ${isActive ? '#9ae6b4' : '#e2e8f0'}`,
        background: isActive ? '#c6f6d5' : '#f7fafc',
        color: isActive ? '#276749' : '#718096',
        cursor: isActive || saving ? 'default' : 'pointer',
        transition: 'background 0.15s, color 0.15s, border-color 0.15s',
        whiteSpace: 'nowrap',
      }}
    >
      {isActive ? '✓ Home page' : saving ? '…' : '🏠 Set as home'}
    </button>
  );
};

export default SetHomepageButton;
